module.exports = __webpack_public_path__ + "static/media/sliderimg2.f65bab3c.jpg";